import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Route guard for the Programs section.
 * Programs is gated per-account. Default OFF; admin toggles per teacher.
 * If a teacher reaches /programs/* without entitlement, redirect to /browse.
 */
export function ProgramsGate() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  if (!user.programs_enabled) {
    return <Navigate to="/browse" replace data-testid="programs-gate-redirect" />;
  }
  return <Outlet />;
}
